import { Button as ChakraButton, Box } from "@chakra-ui/react";
// import "./Button.css";
import { FC } from "react";

interface CustomSwitchProps {
  options: { text: string; value: string }[];
  value: string;
  onChange: (value: string) => void;
  isDisabled?: boolean;
}

const CustomSwitch: FC<CustomSwitchProps> = ({
  options,
  value,
  onChange,
  isDisabled,
}) => {
  const handleClick = (option: string) => {
    if (onChange) onChange(option);
  };

  return (
    <Box
      borderRadius="10px"
      bg="#F4F4F1"
      borderWidth="1px"
      borderColor="#DEDEDA"
      p="3px"
      w={"fit-content"}
      h={"fit-content"}
      display="inline-flex"
      flexWrap="nowrap"
      alignItems="center"
    >
      {options.map((option, index) => (
        <ChakraButton
          h="30px"
          minW="46px"
          flexShrink={0}
          borderRadius="7px"
          w={"fit-content"}
          isDisabled={isDisabled}
          aria-pressed={value === option.value}
          key={index + option.value}
          onClick={() => handleClick(option.value)}
          bg={value === option.value ? "#111111" : "transparent"}
          color={value === option.value ? "white" : "#555B58"}
          _hover={
            isDisabled
              ? {}
              : { bg: value === option.value ? "#111111" : "#E9E9E5" }
          }
          fontFamily={"font4"}
          fontSize="12px"
          fontWeight={600}
        >
          {option.text}
        </ChakraButton>
      ))}
    </Box>
  );
};

export default CustomSwitch;
